import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolbarComponent } from './components/toolbar/toolbar.component';
import { FooterComponent } from './components/footer/footer.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import {RouterModule} from "@angular/router";
import {MatMenuModule} from "@angular/material/menu";
import {TranslateModule} from "@ngx-translate/core";
import {IconRegisterService} from "../../core/services/icon-register.service";

@NgModule({
  declarations: [
    ToolbarComponent,
    FooterComponent
  ],
    imports: [
        CommonModule,
        MatButtonModule,
        MatIconModule,
        RouterModule,
        MatMenuModule,
        TranslateModule
    ],
  exports: [
    ToolbarComponent,
    FooterComponent
  ]
})
export class LayoutModule {
  constructor(private readonly iconsRegisterService: IconRegisterService) {
    iconsRegisterService.registerIcon('burger-menu-icon', '/assets/icons/burger-menu.svg');
    iconsRegisterService.registerIcon('close-icon', '/assets/icons/close-menu.svg');
    iconsRegisterService.registerIcon('profile-icon', '/assets/icons/profile-icon.svg');
  }
}
